import { EntityBase } from './EntityBase';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class RIFMContent extends EntityBase {

    /// <code> Place custom code between <code> tags

    /// </code>

    // Generated code. Do not place code below this line.
    rIFMContentId: number;
    contentData: string;
    contentDataType: string;
    contentName: string;
    created: Date;
    createdUser: string;
    enabled: boolean;
    modified: Date;
    modifyUser: string;
    rowVersion: number;
}

